import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getShopifyToken({ payload: { id, signal, handledErrors, onSuccess } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.shopify.get_token,
      id,
      signal
    });

    onSuccess && onSuccess(data);
    yield put(actions.getShopifyTokenDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyTokenFailed,
      handledErrors,
      endpoint: api.shopify.get_token.url
    });
  }
}

export const getShopifyTokenSaga = takeEvery(types.GET_SHOPIFY_TOKEN_REQUEST, getShopifyToken);